export default "__VITE_ASSET__2f1841e6__"